// extracted by mini-css-extract-plugin
export var equalColumn = "_ei-0";